import { useQuery } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";

import { SkeletonProductDetail } from "../components/skeletons/productDetail";
import { LayoutGrid } from "../components/LayoutContainers";
import ProductDetailTabs from "../components/ProductDetailPage/ProductDetailTabs";
import HeroProductDetail from "../components/ProductDetailPage/HeroProductDetail";
import StatsRow from "../components/StatsRow";
import { fetchInstrumentoDetail } from "../utils/fetchers";
import { formatPriceToAR } from "../utils/utils";

export default function ProductDetailPage({ item }) {
    const navigate = useNavigate();

    const { productType, productId } = useParams();

    const {
        isLoading: isLoading,
        data: itemDetail,
        isRefetching,
        isError,
    } = useQuery({
        queryKey: ["productDetail", { type: productType, symbol: productId }],
        queryFn: () => fetchInstrumentoDetail({ type: productType, symbol: productId }),
        select: (data) => {
            const item = data[0];

            const parsedItem = {
                ...item,
                montoOperado: formatPriceToAR(item.montoOperado),
                precioCierre: formatPriceToAR(item.precioCierre),
                precioCierreAnterior: formatPriceToAR(item.precioCierreAnterior),
                precioMaximo: formatPriceToAR(item.precioMaximo),
                precioMinimo: formatPriceToAR(item.precioMinimo),
                precioApertura: formatPriceToAR(item.precioApertura),
                precioUltimaOperacion: formatPriceToAR(item.precioUltimaOperacion),
                precioMejorOrdenCompra: formatPriceToAR(item.precioMejorOrdenCompra),
                precioMejorOrdenVenta: formatPriceToAR(item.precioMejorOrdenVenta),
            };

            return parsedItem;
        },
    });

    const {
        descripcion,
        moneda,
        montoOperado,
        precioApertura,
        precioCierre,
        precioCierreAnterior,
        precioMaximo,
        precioMinimo,
    } = itemDetail || {};

    const productDetailTabProps = {
        data: {
            descripcion,
        },
        item,
        isLoading,
    };

    if (isError) {
        navigate("/error");
    }

    return (
        <>
            {isLoading || isRefetching ? (
                <SkeletonProductDetail />
            ) : (
                <>
                    <HeroProductDetail item={itemDetail} />

                    <StatsRow
                        isLoading={isLoading}
                        data={{
                            moneda,
                            montoOperado,
                            precioApertura,
                            precioCierre,
                            precioCierreAnterior,
                            precioMaximo,
                            precioMinimo,
                        }}
                    />

                    <LayoutGrid spacingTop="0" spacingBottom="2" cols={1} classNames="cot-product-detail-tabs">
                        <ProductDetailTabs {...productDetailTabProps} />
                    </LayoutGrid>
                </>
            )}
        </>
    );
}
